import Stack from '@mui/material/Stack'
import Divider from '@mui/material/Divider'
import { CancelButton, SaveButton } from '../../../../global/Button'
import ActionBar from '../../../../global/Widget/ActionBar'
import { IPermission } from '../../../../../compiler/global.interface'
import { FieldValues, useFieldArray, UseFormReturn } from 'react-hook-form'
import { useEditUserPermissionByUUID } from '../../../../../hook/query/userCRUD'
import { useSnackbar } from 'notistack'
import { EHelperText } from '../../../../../utilitie/validation'
import { useSettingAccessUserPageContextContext } from '../../../../../pages/Setting/Access/User'
import HierarchicalPermissionTable from '../HierarchicalPermissionTable'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import { PermissionInheritanceMap } from './permissionInheritance'

export interface IUserAccessManageProps {
  usePermissionForm: UseFormReturn<{ permissionData: IPermission[] }, object>
  inheritedPermissions?: PermissionInheritanceMap
  isInheritedLoading?: boolean
}


export default function UserAccessManage({
  usePermissionForm,
  inheritedPermissions = {},
  isInheritedLoading = false,
}: IUserAccessManageProps) {

  const { enqueueSnackbar } = useSnackbar()
  const { uuid, defaultValues } = useSettingAccessUserPageContextContext()

  const { mutateAsync: editUserPermissionByUUID, isLoading: editUserPermissionByUUIDLoading } = useEditUserPermissionByUUID(uuid)

  const { control, reset, handleSubmit, setValue, getValues, formState: { isValid } } = usePermissionForm

  const permissionFieldValues = useFieldArray({ control, name: 'permissionData' })


  const _handleSubmit = async (values: FieldValues) => {
    await editUserPermissionByUUID(values.permissionData as IPermission[]).then(() => {
      enqueueSnackbar(EHelperText.UPDATED_SUCCESS, { variant: 'success' })
    }).catch(error => {
      enqueueSnackbar(EHelperText.AN_ERROR_OCCURRED, { variant: 'error' })
    })
  }

  const handleCancel = () => {
    reset(defaultValues.usePermissionForm)
  }

  const isReadyToAction = !editUserPermissionByUUIDLoading && isValid

  return (
    <Stack height={'100%'}>
      <Box px={2} pt={2}>
        <Alert severity="info">
          ช่องติ๊กคือสิทธิ์ที่กำหนดตรงให้ User ส่วนป้าย “จากกลุ่ม” เป็นสิทธิ์สืบทอดแบบอ่านอย่างเดียว
          สิทธิ์ใช้งานจริง = User OR กลุ่มที่เปิดใช้งาน
        </Alert>
      </Box>
      <HierarchicalPermissionTable
        control={control}
        setValue={setValue}
        getValues={getValues}
        permissionFields={permissionFieldValues.fields}
        replaceFields={permissionFieldValues.replace}
        inheritedPermissions={inheritedPermissions}
        isInheritedLoading={isInheritedLoading}
      />
      <Divider />
      <ActionBar>
        <CancelButton disabled={!isReadyToAction} onClick={handleCancel}>ยกเลิก</CancelButton>
        <SaveButton disabled={!isReadyToAction} onClick={handleSubmit(_handleSubmit, error => console.error(error))}>บันทึก</SaveButton>
      </ActionBar>
    </Stack>
  );
}
